import React, { forwardRef } from 'react';
import ClosePairedWithText from '../text-pairing/Close';
const Close = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 18 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "M18.015 19.957 10.058 12l7.957-7.958-1.058-1.057L9 10.942 1.042 2.985-.015 4.042 7.942 12l-7.957 7.957 1.057 1.058L9 13.058l7.958 7.957z", fill: "currentColor" }))));
Close.displayName = 'Close';
// @ts-ignore;
const iconData = {
    glyph: Close,
    group: 'basic',
    textPairingGlyph: ClosePairedWithText,
};
export default iconData;
export const cross = {
    ...iconData,
    alias: true,
    aliasFor: 'close',
    textPairingGlyph: ClosePairedWithText,
};
